import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'

function VehicleCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Uusi auto lisätty</h2>
    </div>
  )
}

function AddVehicle(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    registerPlate: '',
    phoneNumber: '',
    numberOfSeats: '',
    vehicleId: '',
    priorityGroup: '',
  })
  const [doesExist, setDoesExist] = useState(false)
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer
  // onChange functions
  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }
  const doesIdExist = async (e) => {
    try {
      let ID = e.target.value
      let newID = ''

      newID = await axios.get(`${SERVER_URI}/does_vehicle_exist/${ID}`, {
        headers: { Authorization: `Token ${userToken}` },
      })
      let exists = newID.data.vehicleExists
      if (exists === false) {
        setUserData({ ...userData, vehicleId: ID })
        setDoesExist(false)
      } else {
        alert('Auton Id on jo käytössä')
        setDoesExist(true)
      }
    } catch (e) {
      console.log('Error in ID', e)
    }
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    console.log(userData)
    const dataToServer = {
      ...userData,
      numberOfSeats: Number(userData.numberOfSeats),
      vehicleId: Number(userData.vehicleId),
    }
    if (doesExist === false) {
      try {
        await axios.post(`${SERVER_URI}/add_vehicle/`, dataToServer, {
          headers: { Authorization: `Token ${userToken}` },
        })
        props.dispatch({ type: 'ADD_VEHICLE', data: { newVehicle: dataToServer } })
        setShow(!show)
      } catch (e) {
        console.log('Error in adding car', e)
      }
    } else {
      alert('Id ei ole kelvollinen')
    }
  }

  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Lisää auto</h2>
              <form className='addVehicle_form' onSubmit={(e) => doSubmit(e)}>
                <label className='label_add' htmlFor='registerPlate'>
                  Rekisterinumero:
                </label>
                <input
                  type='text'
                  id='registerPlate'
                  name='registerPlate'
                  onChange={onChange}
                  placeholder='Rekisterinumero'
                  required
                ></input>
                <span className='validity'></span> <br className='desktop-break' />
                <label className='label_add' htmlFor='phoneNumber'>
                  Auton puhelinnumero:
                </label>
                <input
                  type='tel'
                  id='phoneNumber'
                  name='phoneNumber'
                  pattern='[0-9]{7,15}'
                  placeholder='Puhelinnumero'
                  onChange={onChange}
                  required
                ></input>
                <span className='validity'></span>
                <br className='desktop-break' />
                <label className='label_add' htmlFor='numberOfSeats'>
                  Paikkojen määrä:
                </label>
                <input
                  type='number'
                  id='numberOfSeats'
                  name='numberOfSeats'
                  placeholder='Paikkojen määrä'
                  onChange={onChange}
                  required
                ></input>
                <span className='validity'></span>
                <br className='desktop-break' />
                <label className='label_add' htmlFor='priorityGroup'>
                  Prioriteettiryhmä:
                </label>
                <select id='priorityGroup' name='priorityGroup' onChange={onChange} value={userData.priorityGroup}>
                  <option value=''>Valitse prioriteettiryhmä</option>
                  {props.priorityGroups.map((priorityGroup) => (
                    <option key={priorityGroup.group} value={priorityGroup.group}>
                      {`${priorityGroup.group} - ${priorityGroup.delayTime} min`}
                    </option>
                  ))}
                </select>
                <span className='validity'></span>
                <br className='desktop-break' />
                <label className='label_add' htmlFor='vehicleId'>
                  Auton ID:
                </label>
                <input
                  type='number'
                  id='vehicleId'
                  name='vehicleId'
                  placeholder='ID'
                  min='1'
                  max='5000000000'
                  onChange={doesIdExist}
                  required
                ></input>
                <span className='validity'></span>
                <br className='desktop-break' />
                <input type='submit' id='gradient_Button' value='Lisää auto' />
              </form>
            </div>
          )}
          {show && <VehicleCreatedMessage handleClose={props.handleClose} />}
        </div>
      </div>
    </div>
  )
}

export default AddVehicle
